import PaymentManagement from '../../Common/Payment/PaymentManagement';
import { useCreateCommonPayment } from '../../Common/apiEndpoints/commonApiEndpoints';
import { useExhibitorAuthContext } from '../../../Context/AuthContex/ExhibitorAuthContext';

const ExhibitorPayment = () => {
  const {
    state: { exhibitorUser },
    dispatch: authDispatch,
  } = useExhibitorAuthContext();
  const { mutate, isSuccess, data } = useCreateCommonPayment();

  return (
    <PaymentManagement
      isSuccess={isSuccess}
      redirectUrl={`/profile/view-billing-info/${data?.data?.invoice_id}`}
      navigateUrl={`/profile/billing-info`}
      onChangeValue={async ({ payable_amount, ...data }) => {
        const formData = new FormData();
        const allValue = {
          ...data,
          user_id: exhibitorUser.user_fair_member_id,
          user_type: 'Exhibitor',
          payment_type: 'offline',
        };
        Object.keys(allValue).forEach((key) => {
          if (typeof allValue[key] === 'object') {
            formData.append(key, allValue[key][0]);
          } else {
            formData.append(key, allValue[key]);
          }
        });
        await mutate(formData);
      }}
    />
  );
};

export default ExhibitorPayment;
